var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./PlayVideoDialog.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-23a6ec58!../../node_modules/vue-loader/lib/selector?type=template&index=0!./PlayVideoDialog.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/modals/PlayVideoDialog.vue
// module id = 686
// module chunks = 0